import { Dispatch, SetStateAction } from "react"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { TestResultForm } from "../../types"

type CFUField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
}

const CFUField = (props: CFUField) => {
  const { formData, setFormData } = props

  const handleChange = (event: SelectChangeEvent<string>) => {
    const nextForm = structuredClone(formData)

    const value = event.target.value
    const cfu = value || null

    nextForm.cfu = cfu

    setFormData(nextForm)
  }

  const label = 'CFU/ML *'
  const value = formData.cfu ?? ''
  const placeholder = 'Select a Range'

  const options = [
    {
      label: 'Pass (<500 CFUs)',
      value: '499'
    },
    {
      label: 'Fail (>=500 CFUs)',
      value: '500'
    }
  ]

  return (
    <Box>
      <FormControl fullWidth size="small" sx={{ width: '95%' }}>
        <InputLabel>
          { label }
        </InputLabel>
        <Select
          value={value}
          label={label}
          onChange={(event) => handleChange(event)}
          placeholder={placeholder}
        >
          {
            options.map(option => {
              return (
                <MenuItem key={option.value} value={option.value}>
                  { option.label }
                </MenuItem>
              )
            })
          }
        </Select>
      </FormControl>
    </Box>
  )
}

export default CFUField
